import Body from "../components/layout/Body";
import FileDetails from "../components/FileDetails";
import FolderListingSidebar from "../components/layout/Sidebar/FolderListingSidebar";

const FilePage = () => {
    return <>
        <Body mainElement={<FileDetails />} sideBar={<FolderListingSidebar />} />
    </>;
}

export default FilePage; 